import React from 'react'
import { css } from '@emotion/react'

export default ({ direction }) => (
  <svg
    css={css`
      fill: white;
      float: ${direction === 'down' ? 'left' : 'right'};
      height: 12px;
      margin: ${direction === 'down' ? '10px 10px 0 -5px' : '10px 0 0 10px'};
      position: relative;
      transform: ${direction === 'down' ? 'rotate(90deg)' : 'rotate(0)'};
      transition: transform 0.2s ease-out;
      width: 14px;
      will-change: transform;

      a:hover & {
        transform: ${direction === 'down'
          ? 'rotate(90deg) translate(3px, 0)'
          : 'translate(5px, 0)'};
      }
    `}
    viewBox="0 0 14 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.026 5L6.513 1.487 8 0l6 6-6 6-1.487-1.487L10.026 7H0V5h10.026z" />
  </svg>
)
